import React, { useState } from 'react';
import AdminDeleteComponent from './AdminDeleteComponent';
import AdminDeleteStatusComponent from './AdminDeleteStatusComponent';
import AdminRestoredStatusComponent from './AdminRestoredStatusComponent ';
import DatePicker from "react-datepicker";
import AdminAttendance from './AdminAttendance';
import { GET_LOGS_ATTENDANCE_API_URL } from '../Optics/OpticApiConfig';


const Administration = () => {
    const [openDeleteCom, setOpenDeleteCom] = useState(false);
    const [openDeleteStatus, setOpenDeleteStatus] = useState(false);
    const [openRestoreStatus, setOpenRestoreStatus] = useState(false);
    const [openAttendance, setOpenAttendance] = useState(false);

    const openModalDeleteCom = () => setOpenDeleteCom(true);
    const closeModalDeleteCom = () => setOpenDeleteCom(false);

    const openModalDeleteStatus = () => setOpenDeleteStatus(true);
    const closeModalDeleteStatus = () => setOpenDeleteStatus(false);

    const openModalRestoreStatus = () => setOpenRestoreStatus(true);
    const closeModalRestoreStatus = () => setOpenRestoreStatus(false);
    const closeModalAttendanceStatus = () => setOpenAttendance(false);

   
      const [selectedDate, setSelectedDate] = useState(new Date());
        const [attendanceData, setAttendanceData] = useState([]);

          const openModalAttendance = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${GET_LOGS_ATTENDANCE_API_URL}?date=${selectedDate.toISOString().split("T")[0]}`, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error("Ошибка при загрузке данных");
            const data = await response.json();
            setAttendanceData(data);
            setOpenAttendance(true);
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '20px' }}>
         <div> 
        <div className='divDeleteAdmin' style={{ flex: '1', marginRight: '10px' }}>
            <label style={{ color: '#b3b3b3', fontSize: '16px', fontFamily: 'unset' }}>Удаление компонента с базы</label>
            <hr className='horizontalLineModal' />
            <button className='buttonIsDeleteModal' style={{ fontSize: '14px' }} onClick={openModalDeleteCom}>Удалить</button>
            <AdminDeleteComponent open={openDeleteCom} onClose={closeModalDeleteCom} />
        </div>
<div className='divDeleteAdmin' style={{ flex: '1' }}>
            <label style={{ color: '#b3b3b3', fontSize: '16px', fontFamily: 'unset' }}>Удаление компонентов где Status=0</label>
            <hr className='horizontalLineModal' />
            <button className='buttonIsDeleteModal' style={{ fontSize: '14px' }} onClick={openModalDeleteStatus}>Удалить</button>
            <AdminDeleteStatusComponent open={openDeleteStatus} onClose={closeModalDeleteStatus} />
        </div>
        <div className='divRestoreAdmin' style={{ flex: '1' }}>
            <label style={{ color: '#b3b3b3', fontSize: '16px', fontFamily: 'unset' }}>Васстановить где Status=0</label>
            <hr className='horizontalLineModal' />
            <button className='buttonIsRestoreModal' style={{ fontSize: '14px' }} onClick={openModalRestoreStatus}>Васстановить</button>
            <AdminRestoredStatusComponent open={openRestoreStatus} onClose={closeModalRestoreStatus} />
        </div>
        </div> 

        <div className='divRestoreAdmin' >
              <label style={{ color: '#b3b3b3', fontSize: '16px', fontFamily: 'unset' }}>Посещаемость</label>
              <hr className='horizontalLineModal' />
             <DatePicker
                        selected={selectedDate}
                        onChange={(date) => setSelectedDate(date)}
                        dateFormat="yyyy-MM-dd"
                        placeholderText="Выберите дату"
                        className="inputDescriptionModal"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        shouldCloseOnSelect={false}
                        open={false}
                      />
            
                      <button className='buttonAutoTopology' onClick={openModalAttendance}  style={{ marginLeft: "10px",  marginTop: "10px" }}>
                       Отобразить
                      </button>
                       <AdminAttendance open={openAttendance} onClose={closeModalAttendanceStatus}  data={attendanceData}/>
        </div>
    
        

         
{/*
        <div className='divChangeAdmin' style={{ flex: '1' }}>
            <label style={{ color: '#b3b3b3', fontSize: '16px', fontFamily: 'unset' }}>Скрыть где Status=1</label>
            <hr className='horizontalLineModal' />
            <button className='buttonIsChangeModal' style={{ fontSize: '14px' }} onClick={openModalRestoreStatus}>Скрыть</button>
            <AdminDeleteComponent open={openRestoreStatus} onClose={closeModalRestoreStatus} />
        </div>

        <div className='divChangeAdmin' style={{ flex: '1' }}>
            <label style={{ color: '#b3b3b3', fontSize: '16px', fontFamily: 'unset' }}>Изменить создателя компонента</label>
            <hr className='horizontalLineModal' />
            <button className='buttonIsChangeModal' style={{ fontSize: '14px' }} onClick={openModal}>Изменить</button>
            <AdminDeleteComponent open={open} onClose={closeModal} />
        </div> */}
        
    </div>
    


       
    );
};

export default Administration;
























